import gql from 'graphql-tag';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { LastCallerSubscriptionQuery } from '@/gql/graphql';

export type LastCallerSubscription = NonNullable<LastCallerSubscriptionQuery['lastCallerSubscription']>;

export const fetchLastCallerSubscription = async (
  phoneNumber: string,
): Promise<LastCallerSubscription | null> => {
  const response = await queryExecute({
    query: gql`
      query LastCallerSubscription($phoneNumber: String) {
        lastCallerSubscription(phoneNumber: $phoneNumber) {
          id
          callerId
          planName
          callerDescription
          planAmount
          isActive
          isTrial
          periodStartAt
          periodEndAt
        }
      }
    `,
    variables: {
      phoneNumber,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data?.lastCallerSubscription ?? null;
};
